import React, { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import "../css/AddUnit.css";

const AddAsset = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  const API_URL = process.env.REACT_APP_API_URL || "";

  const [name, setName] = useState("");
  const [description, setDescription] = useState("");
  const [amount, setAmount] = useState("");
  const [purchaseDate, setPurchaseDate] = useState(
    new Date().toISOString().split("T")[0]
  );

  const [isSubmitting, setIsSubmitting] = useState(false);
  const [toast, setToast] = useState({ show: false, message: "", type: "" });
  const [isEditMode, setIsEditMode] = useState(false);

  useEffect(() => {
    if (id) {
      setIsEditMode(true);
      // Fetch asset data for editing
      const fetchAsset = async () => {
        try {
          const response = await fetch(`${API_URL}list-assets.php`, {
            method: "POST",
          });
          const data = await response.json();
          if (data.status === true && Array.isArray(data.data)) {
            const asset = data.data.find((a) => String(a.id) === String(id));
            if (asset) {
              setName(asset.name || "");
              setDescription(asset.description || "");
              setAmount(asset.amount || "");
              setPurchaseDate(asset.purchase_date || new Date().toISOString().split("T")[0]);
            } else {
              showToast("Asset not found.", "error");
              setTimeout(() => navigate("/asset-list"), 1500);
            }
          } else {
            showToast("Failed to load asset.", "error");
            setTimeout(() => navigate("/asset-list"), 1500);
          }
        } catch (error) {
          showToast("Network error. Please try again.", "error");
          setTimeout(() => navigate("/asset-list"), 1500);
        }
      };
      fetchAsset();
    } else {
      setIsEditMode(false);
      // Reset form fields for add mode
      setName("");
      setDescription("");
      setAmount("");
      setPurchaseDate(new Date().toISOString().split("T")[0]);
    }
  }, [id, API_URL, navigate]);

  const showToast = (message, type = "success") => {
    setToast({ show: true, message, type });
    setTimeout(() => {
      setToast({ show: false, message: "", type: "" });
    }, 3000);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);

    const assetData = {
      name,
      description,
      amount: parseFloat(amount),
      purchase_date: purchaseDate,
    };

    try {
      let response, data;
      if (isEditMode) {
        // Edit asset
        response = await fetch(`${API_URL}edit-asset.php`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ id, ...assetData }),
        });
        data = await response.json();
        if (data.status === true) {
          showToast("Asset updated successfully!", "success");
          setTimeout(() => navigate("/asset-list"), 1500);
        } else {
          showToast(data.message || "Failed to update asset.", "error");
        }
      } else {
        // Add asset
        response = await fetch(`${API_URL}add-asset.php`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(assetData),
        });
        data = await response.json();
        if (data.status === true) {
          showToast("Asset added successfully!", "success");
          setTimeout(() => navigate("/asset-list"), 1500);
        } else {
          showToast(data.message || "Failed to add asset.", "error");
        }
      }
    } catch (error) {
      showToast("Network error. Please try again.", "error");
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="add-category-content">
      <div className="page-header" style={{ display: "block" }}>
        <h1>{isEditMode ? "Edit Asset" : "Add New Asset"}</h1>
        <p>{isEditMode ? "Update asset details" : "Record a new company asset"}</p>
      </div>
      <div className="form-container">
        <form onSubmit={handleSubmit} className="add-unit-form">
          <div className="form-group">
            <label htmlFor="name">Asset Name</label>
            <input
              type="text"
              id="name"
              value={name}
              onChange={(e) => setName(e.target.value)}
              required
              disabled={isSubmitting}
              placeholder="e.g., Office Chair, Laptop"
            />
          </div>
          <div className="form-group">
            <label htmlFor="description">Description</label>
            <textarea
              id="description"
              value={description}
              onChange={(e) => setDescription(e.target.value)}
              required
              disabled={isSubmitting}
              rows="3"
            ></textarea>
          </div>
          <div className="form-group">
            <label htmlFor="amount">Amount (₹)</label>
            <input
              type="number"
              id="amount"
              value={amount}
              onChange={(e) => setAmount(e.target.value)}
              required
              disabled={isSubmitting}
            />
          </div>
          <div className="form-group">
            <label htmlFor="purchaseDate">Purchase Date</label>
            <input
              type="date"
              id="purchaseDate"
              value={purchaseDate}
              onChange={(e) => setPurchaseDate(e.target.value)}
              required
              disabled={isSubmitting}
            />
          </div>
          <button type="submit" className="submit-btn" disabled={isSubmitting}>
            {isSubmitting
              ? isEditMode
                ? "Updating..."
                : "Adding Asset..."
              : isEditMode
              ? "Update Asset"
              : "Add Asset"}
          </button>
        </form>
      </div>
      {toast.show && (
        <div className={`toast toast-${toast.type}`}>
          <div className="toast-content">
            <span className="toast-message">{toast.message}</span>
            <button
              className="toast-close"
              onClick={() => setToast({ show: false, message: "", type: "" })}
            >
              ×
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default AddAsset;
